import { useState } from 'react'
import {
  Card, CardContent, Typography, Box, IconButton, Tooltip,
  Dialog, DialogTitle, DialogContent,
} from '@mui/material'
import OpenInFullIcon from '@mui/icons-material/OpenInFull'
import CloseIcon from '@mui/icons-material/Close'

// Wrapper comum a todos os gráficos: cabeçalho (+ controlo opcional à direita)
// e área de gráfico com altura controlada pela LINHA a que pertence (a altura
// vem por prop e é ajustada pela barra de resize entre linhas). Botão para
// maximizar num diálogo grande. O gráfico (`children`) é renderizado no cartão
// OU no diálogo, nunca nos dois ao mesmo tempo.
export default function ChartCard({ title, subtitle, height = 220, headerRight, children }) {
  const [max, setMax] = useState(false)

  const Header = (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
      <Typography sx={{ fontSize: 13, fontWeight: 600, color: 'text.primary' }}>
        {title}
        {subtitle && (
          <Typography component="span" sx={{ fontSize: 13, fontWeight: 400, color: 'text.secondary', ml: 0.5 }}>
            · {subtitle}
          </Typography>
        )}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        {headerRight}
        <Tooltip title="Maximise">
          <IconButton size="small" onClick={() => setMax(true)}><OpenInFullIcon sx={{ fontSize: 16 }} /></IconButton>
        </Tooltip>
      </Box>
    </Box>
  )

  return (
    <>
      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 3, height: '100%' }}>
        <CardContent sx={{ p: '12px 16px 10px !important', display: 'flex', flexDirection: 'column', height: '100%' }}>
          {Header}
          <Box sx={{ height, position: 'relative', mt: 1 }}>
            {!max && children}
          </Box>
        </CardContent>
      </Card>

      <Dialog open={max} onClose={() => setMax(false)} maxWidth="lg" fullWidth>
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: 16, fontWeight: 600 }}>
          <span>{title}{subtitle ? ` · ${subtitle}` : ''}</span>
          <IconButton size="small" onClick={() => setMax(false)}><CloseIcon sx={{ fontSize: 18 }} /></IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ height: '72vh', position: 'relative' }}>
            {max && children}
          </Box>
        </DialogContent>
      </Dialog>
    </>
  )
}
